const services = [
  {
    title: 'Web Разработка',
    description: 'Полностью разработаю и выложу в интернет ваш сайт-визитку, интернет-магазин и т.д. Принимаю правки, помогу с регистрацией домена, сертификатов.',
    price: 'От 40$'
  },
  {
    title: 'Web Дизайн',
    description: 'Разработаю весь дизайн вашего будущего продукта: от маленьких компонентов до огромных страниц.',
    price: 'От 25$'
  },
  {
    title: 'Логотип',
    description: 'Разработаю несколько вариантов для вашего логотипа согласно вашему техническому заданию.',
    price: 'От 10$'
  },
  {
    title: '3D Дизайн',
    description: 'Создам 3D модель, сделаю 3D сцену, сделаю рендер согласно вашему техническому заданию.',
    price: 'От 50$'
  },
]

export default services